import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import CancelButton from '../Buttons/CancelButton';

interface WebsiteRebuildModalProps {
    show: boolean;
    onHide: () => void;
    websiteName?: string;
    isConfirming: boolean;
    onConfirm: () => void;
}

const WebsiteRebuildModal: React.FC<WebsiteRebuildModalProps> = ({ show, onHide, websiteName, isConfirming, onConfirm }) => (
    <Modal show={show} onHide={isConfirming ? undefined : onHide} centered backdrop={isConfirming ? 'static' : true}>
        <div className="st-delete-modal-stripe st-delete-modal-stripe--info" />
        <Modal.Header className="st-delete-modal-header">
            <div className="st-delete-modal-header-inner">
                <div className="st-delete-modal-icon-badge st-delete-modal-icon-badge--info">
                    <FontAwesomeIcon icon={faRotate} className="st-delete-modal-icon st-delete-modal-icon--info" />
                </div>
                <span className="st-delete-modal-title">Prebudovať web {websiteName}?</span>
            </div>
        </Modal.Header>
        <Modal.Body className="st-delete-modal-body">
            <p className="st-delete-modal-description">
                Frontend databáza sa vymaže a znovu naplní aktuálnymi dátami. Všetky neodoslané zmeny budú publikované.
            </p>
        </Modal.Body>
        <Modal.Footer className="st-delete-modal-footer">
            <CancelButton onClick={onHide} disabled={isConfirming} />
            <button
                type="button"
                className="st-btn st-btn--success"
                onClick={onConfirm}
                disabled={isConfirming}
            >
                {isConfirming ? <Spinner size="sm" animation="border" /> : <FontAwesomeIcon icon={faRotate} />}
                <span>{isConfirming ? 'Prebudovávam...' : 'Prebudovať'}</span>
            </button>
        </Modal.Footer>
    </Modal>
);

export default WebsiteRebuildModal;
